// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 33 32"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.5}
      d="M29.6667 12H3M19 23.3333L22.3333 20L19 16.6667M13.6667 16.6667L10.3333 20L13.6667 23.3333M3 10.4L3 21.6C3 23.8402 3 24.9603 3.43597 25.816C3.81947 26.5686 4.43139 27.1805 5.18404 27.564C6.03968 28 7.15979 28 9.4 28H23.2667C25.5069 28 26.627 28 27.4826 27.564C28.2353 27.1805 28.8472 26.5686 29.2307 25.816C29.6667 24.9603 29.6667 23.8402 29.6667 21.6V10.4C29.6667 8.15979 29.6667 7.03969 29.2307 6.18404C28.8472 5.43139 28.2353 4.81947 27.4826 4.43598C26.627 4 25.5069 4 23.2667 4L9.4 4C7.15979 4 6.03969 4 5.18404 4.43597C4.43139 4.81947 3.81947 5.43139 3.43597 6.18404C3 7.03968 3 8.15979 3 10.4Z"
    />
  </svg>
);
const IconCodeTabWindow = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconCodeTabWindow;
